var render = function render(){var _vm=this,_c=_vm._self._c;return _c('icon-nav-arrow-right',{staticClass:"sky__icon",class:{
    ['text-' + _vm.color]: true,
    left: _vm.left
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }